export default featuresService

/** @ngInject */
function featuresService(ApiService, $q, ErrorCatcher) {
    let features$ = null
    let features = []

    const getFeaturesPromise = function () {
        if (features$ === null) {
            features$ = ApiService.fetchFeatures()
        .catch((error) => {
            ErrorCatcher.catchError(error)
            return $q.reject(error)
        })
        }

        return features$
    }

    const getFeatures = function (callback) {
        if (features.length < 1) {
            const dfd = $q.defer()
            return getFeaturesPromise().then((response) => {
                features = response
                if (typeof callback === 'function') {
                    dfd.resolve(features)
                    return callback(features)
                }
                dfd.resolve(features)
                return dfd.promise
            })
        }
        if (typeof callback === 'function') {
            return callback(features)
        }
        return features
    }

    const reset = function () {
        features$ = null
        features = []
    }

    return {
        getFeatures,
        getFeaturesPromise,
        reset,
    }
}



// WEBPACK FOOTER //
// ./src/services/features/featuresService.js